import clsx from "clsx";
import { ReactNode } from "react";

import { FCC } from "@/types";

type Styles = {
  desktopContainer?: string;
  mobileContainer?: string;
  mobileText?: string;
};

type Props = {
  ariaLabel?: string;
  customStyles?: Styles;
  icon: ReactNode;
  link: string;
  mobileText: string;
};

export const MenuItem: FCC<Props> = ({
  ariaLabel,
  icon,
  customStyles,
  link,
  mobileText,
}) => {
  return (
    <a
      href={link}
      aria-label={ariaLabel ? ariaLabel : mobileText}
      rel="noreferrer"
      target="_blank"
    >
      {/*Mobile Version*/}
      <div
        className={clsx(
          "mb-4 flex flex-row gap-2 pt-4 md:hidden",
          customStyles?.mobileContainer,
        )}
      >
        {icon}
        <p className={clsx("text-lg text-white", customStyles?.mobileText)}>
          {mobileText}
        </p>
      </div>

      {/*Desktop Version*/}
      <span
        className={clsx(
          "hidden md:visible md:flex md:h-10 md:w-10 md:items-center md:justify-center md:rounded-full md:bg-white md:text-primary-100 md:hover:border-2 md:hover:bg-transparent [&>*>path]:stroke-white md:[&>*>path]:hover:fill-secondary-100",
          customStyles?.desktopContainer,
        )}
      >
        {icon}
      </span>
    </a>
  );
};
